
<div class="container-fluid ">
  <div class="bg-white rounded-3 p-3 shadow-sm" [ngStyle]="{'height': scrHeight, 'overflow': 'auto'}">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5 class="mb-0 fs-6 text-dark-primary">Manage Documents</h5>
    </div>

    <p class="text-secondary small mb-3 subtitle">Review collection files and upload additional documents</p>

    <!-- Department Selection Section -->
    <div class="alert alert-danger-custom mb-3" role="alert">
      <div class="d-flex align-items-center gap-2 mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="text-danger-primary">
          <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="10" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <strong class="text-danger-primary">Select Departments for Upload</strong>
        </div>
        
        <!-- Department Checkboxes -->
        <div class="dept-selection-container mb-3 p-3 bg-white rounded-2 border border-danger-light">
          <div *ngIf="allAvailableDepartments && allAvailableDepartments.length > 0; else noDepts">
            <div class="row g-2">
              <div class="col-12 col-md-6" *ngFor="let dept of allAvailableDepartments">
                <div class="form-check dept-checkbox">
                  <input class="form-check-input" type="checkbox" [id]="'dept-' + dept.id"
                    [checked]="isSelectedDepartment(dept.id)" (change)="toggleDepartmentSelection(dept)">
                  <label class="form-check-label" [for]="'dept-' + dept.id">
                    <span class="fw-500">{{dept.name || dept.id}}</span>
                    <span class="text-secondary small d-block">({{dept.id}})</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noDepts>
            <p class="text-secondary small mb-0">No departments available. Please go back to the Department tab to configure
              departments.</p>
          </ng-template>
        </div>
        
        <!-- Upload Info Section -->
        <div class="upload-info-box p-3 rounded-2 bg-light border border-danger-light">
          <div class="d-flex align-items-start gap-2 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#cc0000"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="flex-shrink-0 mt-1">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <div>
              <strong class="text-danger-primary d-block mb-2">File Upload Destination</strong>
              <span class="text-secondary small d-block">
                Files will be uploaded to the following departments:
              </span>
            </div>
        </div>
        
        <div class="dept-list-inline mt-2">
          <span class="badge badge-danger-custom me-2" *ngFor="let deptId of selectedDepartmentIds">
            {{deptId}}
          </span>
          <span class="text-secondary small" *ngIf="selectedDepartmentIds.length === 0">
            <em>No departments selected - upload disabled</em>
            </span>
            </div>
      </div>
      
      <!-- Warning when no departments selected -->
      <div class="alert alert-danger-warning mb-0 mt-3" *ngIf="!isUploadEnabled" role="alert">
        <div class="d-flex align-items-start gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#cc0000" stroke="none"
            aria-hidden="true" class="flex-shrink-0 mt-1">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
          </svg>
          <div>
            <strong class="text-danger-primary d-block mb-1">⚠️ Upload Disabled</strong>
            <small class="text-dark">Please select at least one department above to enable document uploads.</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3">
      <!-- LEFT: Upload / Drop area -->
      <div class="col-12 col-lg-4">
        <div
          class="border border-2 border-dashed rounded-3 p-4 d-flex flex-column align-items-center justify-content-center bg-white text-center upload-drop-zone"
          [class.opacity-50]="!isUploadEnabled" [style.pointer-events]="!isUploadEnabled ? 'none' : 'auto'"
          (drop)="onDropFiles($event)" (dragover)="onDragOver($event)">
          <button class="btn rounded-circle d-inline-flex align-items-center justify-content-center mb-3 upload-icon-btn"
            aria-label="Upload" (click)="fileInput.click()" [disabled]="!isUploadEnabled">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3v12"></path>
              <path d="m17 8-5-5-5 5"></path>
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            </svg>
          </button>

          <div class="mb-1 text-dark-primary drop-zone-text">Drag &amp; drop files here</div>
          <div class="text-secondary small mb-3">or click the button below to browse</div>

          <label class="btn text-white px-3 py-2 rounded-2 browse-btn" [class.disabled]="!isUploadEnabled">
            <input #fileInput type="file" multiple (change)="onBrowseFiles($event)" hidden [disabled]="!isUploadEnabled">
            <i class="material-icons">add</i><span>Browse Files</span>
          </label>

          <div *ngIf="uploadErrorMessage"
               class="mt-2 text-center w-100 text-danger-primary upload-error"
               role="alert"
               aria-live="polite">
            {{ uploadErrorMessage }}
          </div>

          <div class="mt-3 small text-secondary">Supported: PDF, DOCX, XLSX, PNG, JPG, JPEG, CSV , XLSM (Max 10MB per file)</div>
        </div>
      </div>

      <!-- RIGHT: Files and Uploads -->
      <div class="col-12 col-lg-8">
        <div class="bg-white border rounded-3 d-flex flex-column h-100">
          
          <!-- Uploads section -->
          <div class="border-top border-bottom">
            <div class="d-flex align-items-center gap-2 px-3 py-2 small section-header text-dark-primary">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="text-danger-primary">
                <path d="M12 3v12"></path>
                <path d="m17 8-5-5-5 5"></path>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              </svg>
              Your Upload ({{userUploads.length}} files)
            </div>

            <!-- Uploads list -->
            <div class="overflow-auto uploads-list">
              <div *ngIf="userUploads.length === 0" class="p-3 text-secondary d-flex align-items-center bg-white no-uploads-placeholder">No uploads</div>

              <div class="d-flex justify-content-between align-items-center px-2 py-2 border-bottom bg-white" 
              *ngFor="let u of userUploads">
                <div class="d-flex align-items-center gap-3">
                  <div class="d-flex align-items-center justify-content-center file-icon-container">
                    <app-document-type-icon [item]="u"></app-document-type-icon>
                  </div>

                  <div>
                    <div class="small text-dark-primary">{{u.file_name}}</div>
                    <div class="small text-secondary"> Uploaded for Department :
                      DEPARTMENT-{{u?.department_id}}
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <button class="btn icon-btn icon-btn-lg" (click)="preview(u)" title="Preview">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                            stroke="#374151" stroke-width="1.2" fill="none"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                      <circle cx="12" cy="12" r="2.5" stroke="#374151" stroke-width="1.2"></circle>
                    </svg>
                  </button>

                  <button class="btn icon-btn icon-btn-lg" (click)="download(u)" title="Download">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.2"
                         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M12 15V3"></path>
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <path d="m7 10 5 5 5-5"></path>
                    </svg>
                  </button>

                  <button class="btn icon-btn icon-btn-lg icon-btn-danger text-danger-primary" title="Remove" (click)="removeUpload(u)">
                    <mat-icon class="remove-btn-icon">close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Copy documents from source project (copy mode only) -->
          <app-copy-source-documents
            [projectId]="projectId"
            [projectName]="projectName"
            [workDayId]="workDayId"
            [userName]="userName"
            [selectedDepartmentIds]="selectedDepartmentIds"
            [allAvailableDepartments]="allAvailableDepartments"
            [userUploads]="userUploads"
            (documentsUploaded)="refreshProjectUploads()"
            (previewRequested)="preview($event)"
            (downloadRequested)="download($event)">
          </app-copy-source-documents>

          <!-- Header -->
          <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 px-3 py-2 rounded-top section-header">
            <div class="d-flex align-items-center gap-2 small text-truncate text-dark-primary" style="max-width:100%">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   aria-hidden="true" class="flex-shrink-0 text-danger-primary">
                <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
              </svg>
              <span class="text-truncate">Auto-selected documents from
              {{ createProjectService.getSelectedCollection()?.collection_name
                 || createProjectService.getSelectedCollection()?.collectionName
                 || 'Collection' }}-(<span class="d-none d-sm-inline">{{ collectionCount }} files</span><span class="d-sm-none">{{ collectionCount }}</span>)</span>
            </div>

            <div class="d-flex align-items-center gap-2 flex-shrink-0" *ngIf="files && files.length > 0">
              <span class="small d-none d-sm-inline text-dark-primary">Select All</span>
              <span class="small d-sm-none text-dark-primary">All</span>
              <button class="btn checkbox-btn" (click)="toggleAll()" aria-label="Select all">
                <mat-icon [style.color]="isAllSelected() ? '#cc0000' : '#9aa0a6'" class="checkbox-icon">
                  {{ isAllSelected() ? 'check_box' : 'check_box_outline_blank' }}
                </mat-icon>
              </button>
            </div>
          </div>

          <!-- Collection list -->
          <div class="border-top flex-grow-1 overflow-auto">
            <div class="d-flex justify-content-between align-items-center px-2 py-2 border-bottom" *ngFor="let f of files" [class.bg-danger-subtle]="f.checked">
              <div class="d-flex align-items-center gap-2 gap-sm-3 overflow-hidden min-width-0">
                <button class="btn checkbox-btn flex-shrink-0" (click)="toggleFileSelection(f)" title="Select">
                  <mat-icon [style.color]="f.checked ? '#cc0000' : '#9aa0a6'" class="checkbox-icon">
                    {{ f.checked ? 'check_box' : 'check_box_outline_blank' }}
                  </mat-icon>
                </button>

                <div class="d-none d-sm-flex align-items-center justify-content-center flex-shrink-0 file-icon-container">
                  <app-document-type-icon [item]="f"></app-document-type-icon>
                </div>

                <div class="overflow-hidden min-width-0">
                  <div class="small text-truncate text-dark-primary" title="{{f.file_name}}">{{f.file_name}}</div>
                  <div class="small text-secondary text-truncate">{{DocumentTypeIconComponent.formatDate(f.uploaded_at)}}</div>
                </div>
              </div>

              <div class="d-flex align-items-center gap-1 gap-sm-2 flex-shrink-0">
                <button class="btn icon-btn" (click)="previewCollectionFile(f)" title="Preview">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                          stroke="#374151" stroke-width="1.2" fill="none"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                    <circle cx="12" cy="12" r="2.5" stroke="#374151" stroke-width="1.2"></circle>
                  </svg>
                </button>

                <button class="btn icon-btn" (click)="downloadCollectionFile(f)" title="Download">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                       viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.2"
                       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M12 15V3"></path>
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10 5 5 5-5"></path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Empty state when no files -->
            <div class="d-flex flex-column align-items-center justify-content-center py-4 text-center" *ngIf="files.length === 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="8" y1="13" x2="16" y2="13"></line>
                <line x1="8" y1="17" x2="16" y2="17"></line>
                <line x1="8" y1="9" x2="10" y2="9"></line>
              </svg>
              <div class="text-dark-primary mb-2" style="font-size: 18px; font-weight: normal;">No documents found</div>
              <div class="text-secondary small mb-0">There are no documents auto-selected from collection.</div>
            </div>
          </div>

          

          <!-- Preview overlay -->
          <div class="position-fixed top-0 start-0 end-0 bottom-0 d-flex flex-column preview-overlay" *ngIf="isPreviewOpen">
            <div class="bg-white p-2 d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <h6 class="mb-0 text-dark-primary">{{ previewTitle }}</h6>
              </div>
              <div class="d-flex align-items-center gap-3">
                <div *ngIf="previewType === 'xls'" class="d-flex align-items-center gap-2">
                  <label class="small text-secondary me-1">Sheet</label>
                  <select class="form-select form-select-sm" style="width:auto" [(ngModel)]="selectedSheetIndex"
                          (change)="renderSheetByIndex(selectedSheetIndex)">
                    <option *ngFor="let s of sheetNames; let i = index" [ngValue]="i">{{ s }}</option>
                  </select>
                </div>
                <button class="btn btn-light border-0 rounded-2 d-inline-flex align-items-center justify-content-center preview-close-btn" (click)="closePreview()" aria-label="Close preview">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151"
                       stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>

            <div class="bg-white flex-grow-1 overflow-auto p-2">
              <iframe *ngIf="previewType === 'pdf'" [src]="previewUrl" width="100%" height="100%"></iframe>
              <!-- <div #webviewerContainer *ngIf="previewType === 'pptx'" style="width:100%;height:100%;min-height:600px;"></div> -->
              <img *ngIf="previewType === 'image'" [src]="previewUrl" alt="Image preview" class="preview-image" />
              <div *ngIf="previewType === 'docx'" #docxContainer></div>
              <div *ngIf="previewType === 'xls'" [innerHTML]="excelHtml"></div>
              <p *ngIf="previewType === 'unsupported'" class="text-center text-secondary">Preview not supported for this file type.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
